import { useQuery } from '@tanstack/react-query';

import { teamsKeys } from '~teacher/hook/team/teamsKeys';

import { TeamWithDisplayName, getTeams } from '../../../api/teams';

const DEFAULT_TEAMS_STALE_TIME = 5 * 60 * 1000; // 5 minutes in milliseconds

interface UseTeamsParams<T> {
  select?: (response: Array<TeamWithDisplayName>) => T;
  enabled?: boolean;
}

export function useTeams<T = Array<TeamWithDisplayName>>({
  select,
  enabled = true,
}: UseTeamsParams<T> = {}) {
  return useQuery<Array<TeamWithDisplayName>, unknown, T, typeof teamsKeys.all>(
    teamsKeys.all,
    () => getTeams(),
    {
      select: select,
      enabled: enabled,
      staleTime: DEFAULT_TEAMS_STALE_TIME,
    }
  );
}
